module.exports = __webpack_public_path__ + "img/2.40ee9093.jpg";